module.exports = __webpack_public_path__ + "img/doc_1_preview.379f0bf9.jpg";